module.exports = __webpack_public_path__ + "static/media/pnln-epapers.7742ad51.png";